import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  DeactivateSellersParams,
  DeactivateSellersResponse,
  GenerateInvitationCodesParams,
  GenerateInvitationCodesResponse,
  GetInvitationCodesParams,
  GetInvitationCodesResponse,
  GetPosStatsParams,
  GetPosStatsResponse,
  GetPosTransactionsParams,
  GetPosTransactionsResponse,
  UpdateBalancesParams,
  UpdateBalancesResponse,
  UpdatePosNameParams,
  UpdatePosNameResponse,
  UpdateSellerNamesParams,
  UpdateSellerNamesResponse,
} from '../../';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class SellersService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get point of sale stats
   * @param getPosStatsParams
   */
  getPosStats(
    getPosStatsParams: GetPosStatsParams
  ): Observable<GetPosStatsResponse> {
    let params = new HttpParams();

    Object.keys(getPosStatsParams).forEach((param) => {
      params = params.append(param, getPosStatsParams[param]);
    });

    return this.apiService.get(
      `/v1/brand/${getPosStatsParams.brandUuid}/points-of-sale/statistics`,
      params
    );
  }

  /**
   *  Update balance
   * @param updateBalancesParams
   */
  updateBalances(
    updateBalancesParams: UpdateBalancesParams
  ): Observable<UpdateBalancesResponse> {
    return this.apiService.post(
      `/v1/pos/${updateBalancesParams.posUuid}/balances`,
      updateBalancesParams
    );
  }

  /**
   *  Update PoS Name
   * @param updatePosNameParams
   */
   updatePosName(
    updatePosNameParams: UpdatePosNameParams
  ): Observable<UpdatePosNameResponse> {
    return this.apiService.put(
      `/v1/points-of-sale/point-of-sale/${updatePosNameParams.posUuid}`,
      updatePosNameParams
    );
  }

  /**
   *  Update Seller Name
   * @param updateSellerNamesParams
   */
  updateSellerNames(
    updateSellerNamesParams: UpdateSellerNamesParams
  ): Observable<UpdateSellerNamesResponse> {
    return this.apiService.put(
      `/v1/sellers/seller/${updateSellerNamesParams.sellerUuid}`,
      updateSellerNamesParams
    );
  }

  /**
   * Get point of sale transactions
   * @param getPosTransactionsParams
   */
  getPosTransactions(
    getPosTransactionsParams: GetPosTransactionsParams
  ): Observable<GetPosTransactionsResponse> {
    let params = new HttpParams();

    Object.keys(getPosTransactionsParams).forEach((param) => {
      params = params.append(param, getPosTransactionsParams[param]);
    });

    return this.apiService.get(`/v1/points-of-sale/transactions`, params);
  }

  /**
   * Deactivate sellers
   * @param sellerUuids
   */
  deactivateSellers(
    deactivateSellersParams: DeactivateSellersParams
  ): Observable<DeactivateSellersResponse> {
    return this.apiService.post(
      '/v1/sellers/deactivate',
      deactivateSellersParams
    );
  }

  /**
   * Get invitation codes
   * @param brandUuid
   */
  getInvitationCodes(
    getInvitationCodesParams: GetInvitationCodesParams
  ): Observable<GetInvitationCodesResponse> {
    let params = new HttpParams();

    Object.keys(getInvitationCodesParams).forEach((param) => {
      params = params.append(param, getInvitationCodesParams[param]);
    });

    return this.apiService.get(
      `/v1/sellers/brand/${getInvitationCodesParams.brandUuid}/invitationcodes`,
      params
    );
  }

  /**
   * Generate invitation codes
   * @param generateInvitationCodesParams
   */
  generateInvitationCodes(
    generateInvitationCodesParams: GenerateInvitationCodesParams
  ): Observable<GenerateInvitationCodesResponse> {
    return this.apiService.post(
      '/v1/sellers/invitationcodes',
      generateInvitationCodesParams
    );
  }
}
